import { useSelector, useDispatch } from "react-redux";
import React, { useState, useEffect } from "react";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import FileBase64 from "../../components/Upload/UploadFile";
import Util from "../../validation";
import { countries } from "../../utils/countriesDropdown";
import SaveIcon from "@mui/icons-material/Save";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { Card, Alert } from "reactstrap";
import SOLogout from "../../components/Logout/SOLogout";

import {
    TextField,
    Typography,
    Grid,
    Button,
    MenuItem,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputAdornment,
    IconButton,
} from "@mui/material";
import { dealerAddEditDsr } from "../../redux/actions/dealerAddEditDsrAction"
import { dealerDsrList } from "../../redux/actions/dealerDsrListAction";


const DealerAddNewDsr = () => {

    const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;
    // const classes = useStyles();
    const dispatch = useDispatch();

    const [addDsrStatus, setAddDsrStatus] =
        useState(false);
    const [addDsrStatusResArray, setAddDsrStatusResArray] =
        useState("");


    const [setDsrListStatus, setSetDsrListStatus] = useState(false);
    const [setDsrListArray, setSetDsrListArray] = useState([]);

    const getAddEditDsrListRes = useSelector(({ dealerAddEditDsrLists }) => dealerAddEditDsrLists);

    const setDsrList = useSelector(({ dealerDsrList }) => dealerDsrList);

    const [agentComboName, setAgentComboName] = useState("")
    const [Role, setRole] = useState("");
    const [mobileNo, setMobileNo] = useState("")
    const [getDivision, setGetDivision] = useState("");
    const [getDistrict, setGetDistrict] = useState("");
    const [getThana, setGetThana] = useState("");
    const [getUnion, setGetUnion] = useState("");
    const [getdsrId, setGetdsrId] = useState("");
    const [getEmailOtp, setGetEmailOtp] = useState("");
    const [custId, setCustId] = useState("");
    const [idNum, setIdNum] = useState("");




    const handleChange = ({ target: { name, value } }) => {
        if (name === "AgentComboName") {
            // setAgentComboName(value == "Select Dsr" ? "" : value);
            setAgentComboName(value)
        }
        if (name === "Role") {
            setRole(value);
        }

        if (name === "MobileNumber") {
            setMobileNo(value);
        }

        if (name === "Division") {
            setGetDivision(value)
        }

        if (name === "District") {
            setGetDistrict(value)
        }

        if (name === "Thana") {
            setGetThana(value)
        }

        if (name === "Union") {
            setGetUnion(value)
        }
        if (name === "getEmailOtp") {
            setGetEmailOtp(value);
            // setLevel(value);
        }
    };




    // const AddDsrList = (
    //     agentComboName,
    //     Role,
    //     mobileNo,
    //     getDivision,
    //     getDistrict,
    //     getUnion,
    //     getThana,
    //     getEmailOtp,
    //     custId,
    //     idNum,


    // ) => {

    //     setAgentComboName(agentComboName);
    //     setRole(Role);
    //     setMobileNo(mobileNo);
    //     setGetDivision(getDivision);
    //     setGetDistrict(getDistrict);
    //     setGetUnion(getUnion);
    //     setGetThana(getThana);
    //     setGetEmailOtp(getEmailOtp);
    //     setCustId(custId);
    //     setIdNum(idNum)


    //     // setEditOpen(true)



    // }

    const setDsrListReq = () => {
        setSetDsrListStatus(true);
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || ""


            }
        };
        dispatch(dealerDsrList(req, authToken));
    };
    const DsrListFunc = () => {
        if (setDsrListStatus) {
            if (setDsrList.data.status == "success") {
                setSetDsrListArray([].concat(setDsrList.data.actionList));
            }
            if (setDsrList.data.status == "failed") {
                setSetDsrListArray(setDsrList.data);
                if (
                    setDsrList.data.description == "session out" ||
                    setDsrList.data.description == "Authorization failed"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        DsrListFunc();
    }, [setDsrList.data.status]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            setDsrListReq();
        }
    }, [regenerateTokenRes.data.status]);





    const getAddDsrReq = () => {
        setAddDsrStatus(true)
        const request = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                id: "",
                customerId: custId,
                dsrId: getEmailOtp.split("-")[0]
            }
        }
        dispatch(dealerAddEditDsr(request, authToken))

    }

    const dealerAddDsrFunc = () => {
        if (addDsrStatus) {
            if (getAddEditDsrListRes.data.status == "success") {
                setAddDsrStatusResArray(getAddEditDsrListRes.data)
                // setAddEditDsrNotification(true)
                // dealerDsrMappingListReq()

            }
            if (getAddEditDsrListRes.data.status == "failed") {
                setAddDsrStatusResArray(getAddEditDsrListRes.data)
                // setAddEditDsrNotification(true)
            }
        }
    }

    useEffect(() => {
        dealerAddDsrFunc()
    }, [getAddEditDsrListRes.data.status])




    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >

                        {/* <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="DSR ID"
                                fullWidth={true}
                                name="dsrId"
                                value={dsrId}
                                // onChange={onInputChange}
                                onChange={(e) => onInputChange(e, "number")}
                            ></TextField>
                        </Grid> */}
                        {/* <DialogContent> */}
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Agent/Combo Name"
                            fullWidth={true}
                            name="AgentComboName"
                            value={agentComboName || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Role"
                            fullWidth={true}
                            name="Role"
                            value={Role || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Mobile No"
                            fullWidth={true}
                            name="MobileNumber"
                            value={mobileNo || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Divison"
                            fullWidth={true}
                            name="Division"
                            value={getDivision || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="District"
                            fullWidth={true}
                            name="District"
                            value={getDistrict || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Thana"
                            fullWidth={true}
                            name="Thana"
                            value={getThana || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Union"
                            fullWidth={true}
                            name="Union"
                            value={getUnion || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <div style={{ marginTop: "1.5rem" }}>

                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Dsr"
                                fullWidth={true}
                                // name="dsr"
                                name="getEmailOtp"
                                value={getEmailOtp || ""}
                                // value={level || ""}
                                // defaultValue={"Select Dsr" || dsr}
                                onChange={handleChange}
                            >
                                {/* <MenuItem value="Select Dsr" selected="Select Level">
                                    Select Dsr
                                </MenuItem> */}
                                {/* {setDsrList.success} */}
                                {/* <MenuItem value="BASIC">BASIC</MenuItem> */}
                                {setDsrList.success && [].concat(setDsrList.data.actionList)
                                    .map((x) => <MenuItem value={x.split("-")[0]}
                                    // selected={() => {
                                    //     getEmailOtp == x.substring(0, 6) ? "" : "undefined"
                                    // }}
                                    // selected={dsrDropdown(x)}
                                    // selected={'190032-Soham-7875612343'}
                                    >{x}</MenuItem>)}

                            </TextField>
                            <div className="text-center" style={{ marginTop: "2.5rem" }}>

                                <CustomButton
                                    style={{
                                        // backgroundColor: "#fff",
                                        color: "white"
                                    }}
                                    variant="contained"
                                // onClick={handleClose}
                                >
                                    Cancel
                                </CustomButton>
                                <CustomButton
                                    style={{
                                        // backgroundColor: "#00b9f5",
                                        color: "white"
                                    }}
                                    variant="contained"
                                    onClick={getAddDsrReq}
                                >
                                    Save
                                </CustomButton>
                            </div>
                        </div>
                        {/* </DialogContent> */}
                    </Grid>
                </Card>
            </Layout>
        </>
    )
}

export default DealerAddNewDsr






